// extracted by mini-css-extract-plugin
export default {"nav":"Menu_nav__CAW9R","links":"Menu_links__04uq1","link":"Menu_link__Zpixr","active":"Menu_active__-ZTQy","indicator":"Menu_indicator__1Fv5c"};